import { PiniaColada } from '@pinia/colada'
import Aura from '@primeuix/themes/aura'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import { createApp } from 'vue'

import App from './App.vue'
import { createPiniaColadaOptions } from './api/piniaColada.js'
import { auth0 } from './auth0.js'
import router from './router/index.js'
import './assets/fonts.scss'
import './assets/_variables.scss'
import Observability from './utils/Observability.js'

const app = createApp(App)
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: false,
    },
  },
})
if (!import.meta.env.DEV) {
  Observability.setup(app, router)
}

app.use(createPinia())
// after Pinia, since failed queries report through the error store
app.use(PiniaColada, createPiniaColadaOptions())
app.use(router)
app.use(auth0)

app.mount('#app')
